const _excluded = ["inputClassName", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import '@isyc-react/design/main';
import clsx from 'clsx';
import { InputText } from "../../text";
import "./input-password.style.scss";
export const InputPassword = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      inputClassName,
      className,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  //TOGGLE EYE
  const [inputType, setInputType] = useState('password');
  const [passwordIconEye, setPasswordIconEye] = useState(''); //default
  const togglePassword = () => {
    if (inputType === 'password') {
      setInputType('text');
      setPasswordIconEye('active');
    } else {
      setInputType('password');
      setPasswordIconEye('');
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx(className, 'password-container')
  }, /*#__PURE__*/React.createElement(InputText, _extends({}, rest, {
    type: inputType,
    className: inputClassName
  })), /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'mdi mdi-eye text-primary ' + passwordIconEye,
    onClick: () => togglePassword()
  }), /*#__PURE__*/React.createElement("span", {
    className: 'mdi mdi-eye-off text-primary ' + passwordIconEye,
    onClick: () => togglePassword()
  })), children));
});